import { Component, OnInit } from '@angular/core';
import { ToastService } from '../../_service/Toast.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CouponcodeService } from '../../_service/CouponcodeService';
import { Snackbarerrorformat } from '../../_theme/snackbarformats';
import { filter } from 'rxjs';
import { GlobalService } from 'src/_service/GlobalService';

@Component({
  selector: 'url-couponcode',
  template: '',
  standalone: true,
  providers: []
})
export class UrlCouponcodeComponent implements OnInit {

  constructor(
    public activatedRoute: ActivatedRoute,
    public router: Router,
    private _couponcodeService: CouponcodeService,
    private _toastService: ToastService,
    private _globalService: GlobalService,

  ) {}
  ngOnInit() {

    //normal couponcodes
    this.activatedRoute.queryParams.pipe(
      filter(params => params.code)
    ).subscribe(params => {

      this._couponcodeService.setCouponcode(params.code);

      let codeparams = this._globalService.makeUnique( params);
      codeparams.code = null;
      this.navigate(codeparams)
    })

    //magento couponcodes
    this.activatedRoute.params.subscribe((params: Params) => {
      //if the code is in the url, the code doesnt have to get set by the id
      if (params.code) {
        const codes = params.code.split(',');
        this._couponcodeService.setCouponcode(atob(codes[0]));

        this.navigate(params);

      }
      if (params.magentoid) {
        const ids = params.magentoid.split(',');
        const id = ids[0];
        if (id && id !== '') {
          // console.log('couponcode magentoidid', id, atob(id));
          this._couponcodeService.getMagentoCouponcode(Number(atob(id))).subscribe(result => {
            this.navigate(params);
          }, error => {

            this._toastService.openWithTranslate('couponcode.error_in_checking_code', 'common.ok_dismiss', Snackbarerrorformat);

            this.navigate(params);
          });
        }
      }

    });
  }

  navigate(params: any) {
    if (params.to) {
      this.router.navigateByUrl('/' + params.to)
    } else {
      this.router.navigate([],{
        relativeTo: this.activatedRoute,
        queryParams: params,
        queryParamsHandling: 'merge'
      }
      )

    }
  }

}
